<template>
  <div>
    <div class="modal-background" :class="{'show-modal': showModal, 'modal-close': isClosingModal}"></div>
    <div class="modal" :class="{'show-modal': showModal}" >
      <div class="modal-close-area" @click="closeModal()"></div>
      <div class="modal-container" :class="{'modal-close': isClosingModal}">
        <tech-city-detail :nid="nid" :item="item" :showModal="showModal" @closeModal="closeModal()" v-if="showModal && !isEmpty(node)"></tech-city-detail>
        <div class="close-icon" @click="closeModal()">
          <svg-close-icon width="17" height="17"></svg-close-icon>
        </div>
        <div class="modal-nav">
          <div class="close-button button"
            @click="closeModal()"
            v-gtm-tracker="{ec: 'Inbound Clicks', ea: 'China Tech City Overlay/Exit/Clicks', el: null}"
          >
            <svg-close-icon width="20" height="20"></svg-close-icon>
          </div>

          <toggle-share-buttons
            v-if="mounted && shareUrl"
            :shareUrl="shareUrl"
            mode="Tech City"
            :title="shareTitle"
            :bypassUserInteraction="true"
            @shareHover="shareHover"
            :gtmCustomEvents="{ec: 'Outbound Clicks', ea: 'China Tech City Overlay/Share/Click'}"
          ></toggle-share-buttons>
        </div>
      </div>
    </div>
    <div class="data-source data-source--desktop" v-if="showModal">
      Source: SCMP Data - March 2019
    </div>
  </div>
</template>

<script>
  import get from 'lodash/get'
  import isEmpty from 'lodash/isEmpty'
  import SvgCloseIcon from 'static/svg/icon_close.svg'
  import SvgShareIcon from 'static/svg/icon_share.svg'
  import SvgShareOpen from 'static/svg/tc_share_open.svg'

  import mounted from 'components/mixins/mounted'
  import techCityShareHandler from 'components/mixins/techCityShareHandler'
  import 'swiper/dist/css/swiper.css'
  import { mapState, mapGetters } from 'vuex'
  import GTMManager from 'mixins/gtm-manager'

  export default {
    name: 'tech-city-modal',
    mixins: [
      mounted,
      GTMManager,
      techCityShareHandler,
    ],
    components: {
      SvgCloseIcon,
      SvgShareIcon,
      SvgShareOpen,
      TechCityDetail: () => import('components/tech-city/overlay/TechCityDetail.vue'),
      ToggleShareButtons: () => import('components/widgets/ToggleShareButtons.vue'),
    },
    props: ['showModal', 'item', 'isClosingModal', 'shareItem'],
    computed: {
      ...mapState([
        'viewportIsDesktop',
      ]),
      shareTitle() {
        return get(this, 'shareItem.title', '')
      },
      shareUrl() {
        return get(this, 'shareItem.url')
      },
    },
    methods: {
      isEmpty,
      ...mapGetters(['requestDomain']),
      closeModal() {
        this.$emit('closeModal')
      },
      shareHover(isShow) {
        if (isShow && this.viewportIsDesktop) {
          GTMManager.pushTracker({
            category: 'Hover',
            action: 'China Tech City Overlay/Share/Hover',
          })
        }
      },
      shareTechCity() {
        if (get(this, '$refs[share-wrapper]')) {
          if (this.$refs['share-wrapper'].isNativeWrapper || this.$refs['share-wrapper'].isNative) {
            this.$refs['share-wrapper'].nativeShareClick()
          } else {
            this.isShowPageShareIcon = !this.isShowPageShareIcon
          }
        }
      },
    },
  }
</script>
<style scoped lang="scss">
  $boxShadow: 0 0 14px 0 rgba(0, 0, 0, 0.5);

  @mixin circle-button {
    fill: $white;
    padding: rem-calc(14);
    line-height: rem-calc(20);
    border-radius: 50%;
    line-height: 0;
    box-shadow: $boxShadow;
    margin-bottom: rem-calc(15);
    cursor: pointer;
  }

  .modal-background {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.6);
    top: 0;
    left: 0;
    width: 100vw;
    height: 100%;
    opacity: 0;
    transition: opacity 300ms;
    &.show-modal {
      opacity: 1;
      z-index: 4;
      transition-delay: 250ms;
    }
    &.modal-close {
      opacity: 0;
    }
  }

  .modal-close-area {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  .modal{
    z-index: 0;
    position: absolute;
    width: 100vw;
    height: 100%;
    display: inline-block;

    @include respond-to("desktop") {
      clip-path: circle(0);
      transition: clip-path 1s cubic-bezier(0.77, 0, 0.175, 1);
      transition-delay: 300ms;
    }

    &.show-modal {
      z-index: 5;
      @include respond-to("desktop") {
        clip-path: circle(100vw);
        transition-delay: 0;
        @media (orientation: portrait) {
          clip-path: circle(100%);
        }
      }

      @include respond-to("mobile") {
        .modal-container {
          transform: translateY(0);
        }
      }
      @include respond-to("mobile") {
        clip-path: none;
        transition: 300ms;
        transform: translateY(0);
      }
    }

    $offset: 73px;
    $offsetTop: rem-calc($offset + 60px);  //35 px is for building negative margin.
    $offsetBottom: rem-calc($offset);

    $mobileOffsetTop: rem-calc(73);
    .modal-container{
      display: inline-block;
      position: absolute;
      height: calc(100%  - #{$offsetTop} - #{$offsetBottom} + 50px);
      top: $offsetTop;
      left: 0;
      right: 0;
      padding: 0;
      transition: transform 250ms;
      transform: translateY(0);
      will-change: transform;
      margin: 0 rem-calc(90px);

      @media (min-width: 1200px) {
        margin: 0 rem-calc(120px);
      }

      @include respond-to("mobile") {
        -webkit-overflow-scrolling: touch;
        width: 100%;
        height: calc(100%  - #{$mobileOffsetTop});
        top: $mobileOffsetTop;
        left: 0;
        transition: transform 250ms;
        transition-delay: 300ms;
        transform: translateY(120%);
        margin: 0 auto;
      }

      @include respond-to("hd") {
        width: rem-calc(1250px);
        margin: 0 auto;
      }

      @include respond-to("largedesktop") {
        width: rem-calc(1200px);
      }

      &.modal-close {
        transform: translateY(120%);
      }

      .close-icon {
        display: none;
        @include respond-to("mobile") {
          width: rem-calc(27);
          height: rem-calc(27);
          padding: rem-calc(5);
          position: absolute;
          top: rem-calc(7);
          right: rem-calc(7);
          z-index: 5;
          display: block;

          svg {
            fill: black;
          }
        }
      }
    }
    .modal-nav {
      right: rem-calc(-65);
      top: rem-calc(10);
      position: absolute;
      z-index: 3;

      @include respond-to("mobile") {
        top: auto;
        right: rem-calc(10);
        bottom: rem-calc(10);
      }

      .button {
        @include circle-button;
      }
    }
    .close-button{
      background-color: black;
      padding: rem-calc(15);

      @include respond-to("mobile") {
        display: none;
      }
    }
  }

  .data-source {
    font-size: rem-calc(12);
    color: $timeline-dark-gray;
    position: absolute;
    bottom: rem-calc(5px);
    right: rem-calc(10px);
    z-index: 5;

    @include respond-to("mobile") {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// components/tech-city/overlay/TechCityModal.vue